import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HeaderComponent } from 'src/app/header/header.component';
import { storedValudationData } from 'src/app/models/urlAuthParams.model';
import { finishValuation } from 'src/app/models/valuation-request';
import { valuationByHash } from 'src/app/models/valuation.model';
import { slideInOutAnimation } from 'src/app/route-animations';
import { ApiService } from 'src/app/services/api.service';
import { ValuationService } from 'src/app/services/valuation.service';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-decline-offer',
  templateUrl: './decline-offer.component.html',
  styleUrls: ['./decline-offer.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class DeclineOfferComponent implements OnInit {
  public form: UntypedFormGroup;
  public submitted = false;
  public showFeedback = false;
  public showError = false;
  public valuationData: valuationByHash;

  public declineReasons = [
    { type: "not_selling", value: "Ik heb besloten mijn auto toch niet te verkopen" },
    { type: "trade_in", value: "Ik ga mijn auto inruilen " },
    { type: "higher_bid", value: "Ik had een hoger bod verwacht voor mijn auto, namelijk:" },
    { type: "other", value: "Andere reden" },
  ]

  public selectedReason: any;

  constructor(
    private readonly headerComponent: HeaderComponent,
    public fb: UntypedFormBuilder,
    private readonly ngxService: NgxUiLoaderService,
    private readonly api: ApiService,
    private readonly route: ActivatedRoute,
    private readonly valuationService: ValuationService,
    private readonly router: Router,
  ) {

    this.form = fb.group({
      selectReason: ["", Validators.required],
      reason: [null, null],
      amount: [null, null],
    });
  }

  public ngOnInit(): void {
    this.ngxService.start();
    // Get route params used in servcie
    this.route.params.subscribe((routeParams) => {
      // Sync data
      this.valuationService.syncValuationData(routeParams).then(data => {
        this.valuationData = data;
        // navigate to correct page when valuation has status bough.
        if (this.valuationData.StatusType.name == 'buy') {
          this.router.navigate(['/verificatie', { action: "clicked_decline" }]);
        }
      })
    });
  }

  // Used to shortcut to form for validation.
  public get f() { return this.form.controls; }

  public updateSelectReason() {
    this.selectedReason = this.declineReasons.find(type => type.type === this.form.controls['selectReason'].value);
  }

  public decline() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    } else {
      this.ngxService.start(); // start foreground spinner of the master loader with 'default' taskId
      const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));

      let submitReason = "";
      if (this.form.controls['reason'].value != null) {
        submitReason = this.selectedReason.value + ' ' + this.form.controls['reason'].value
      } else if (this.form.controls['amount'].value != null) {
        submitReason = this.selectedReason.value + ' ' + this.form.controls['amount'].value + ' euro.'
      } else {
        submitReason = this.selectedReason.value;
      }

      const data: finishValuation = {
        reason: submitReason
      }

      this.api.finishValuation(valuationAuth.id, valuationAuth.hash, data).subscribe(data => {
        this.ngxService.stop();
        if (data.error == false) {
          
          // Push Tag manager purchase event
          window['dataLayer'] = window['dataLayer'] || [];
          window['dataLayer'].push({ value: 0});
          window['dataLayer'].push({ currency: 'EUR' });
          window['dataLayer'].push({ email: this.valuationData.Customer.emailAddress });
          window['dataLayer'].push({ valuation_id: this.valuationData.id });
          window['dataLayer'].push({ event: 'reject_bid' });

          this.showFeedback = true;
          localStorage.clear();
          this.headerComponent.getData();
        } else {
          this.showError = true;
          localStorage.clear();
          this.headerComponent.getData();
        }
      })
    }
  }
}
